// extracted by mini-css-extract-plugin
export default {"tabList":"styles_tabList__nY1Jq"};